import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC019_Request,
  IAPI_FAC019_Response,
  IAPI_STA009_Request,
  IAPI_STA009_Response,
  IAPI_STA030_Request,
  IAPI_STA030_Response,
} from "../../../type/apiType";

// プルダウン用有効施設一覧参照
const httpAPI_FAC019 = async (
  param: IAPI_FAC019_Request
): Promise<IAPI_FAC019_Response> => {
  let res = await http.post(ApiUrl.API_FAC019, {
    ...param,
  });

  return res.data;
};

// 配置換え職員一覧参照
const httpAPI_STA009 = async (
  param: IAPI_STA009_Request
): Promise<IAPI_STA009_Response> => {
  let res = await http.post(ApiUrl.API_STA009, {
    ...param,
  });

  return res.data;
};

// 施設新設職員異動更新
const httpAPI_STA030 = async (
  param: IAPI_STA030_Request
): Promise<IAPI_STA030_Response> => {
  let res = await http.post(ApiUrl.API_STA030, {
    ...param,
  });

  return res.data;
};

export { httpAPI_FAC019, httpAPI_STA009, httpAPI_STA030 };
